import React from "react";
import {
  Input,
  Row,
  Col,
  Button,
  Space,
  Dropdown,
  Checkbox,
  Modal,
  Image,
  Tooltip,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { DownOutlined, PlusOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import withRouter from "../withRouter";
import Cookies from "js-cookie";
import { decode as base64_decode } from "base-64";
import VehicleNotPollReportStore from "../store/VehicleNotPollReportStore";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import MapForVehiclePosition from "./MapForVehiclePosition";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import { el } from "date-fns/locale";
class VehicleNotPollReportList extends React.Component {
  constructor(props, context) {
    super(props);

    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.vehicleNotPollReportStore = new VehicleNotPollReportStore();

    this.state = {
      loading: false,
      pageSize: 50,
      // currentPage: 1,
      pageNo: 1,
      offset: 0,
      limit: 50,
      companyId: "",

      modalVisible: false,
      column: "",
      filter: "",

      Notcompany: false,
      Nottime: false,
      vehicleObj: false,
      heading: "",
      selectedColumns: [
        {
          title: context.translate("_FLEET_DASHBORD_RULETRIGGER_VEHICLE_"),
          dataIndex: "vehicleNo",

          width: 15,
          key: "vehicleNo",
          ellipsis: { showTitle: false },
        },
        {
          title: context.translate("_VEHICLE_TYPE_"),
          dataIndex: "vehicleTypeNew",

          width: 10,
          key: "vehicleTypeNew",
          ellipsis: { showTitle: false },
        },

        {
          title: context.translate("_LAST_POLLED_DATETIME_"),
          dataIndex: "timestamp",
          key: "timestamp",

          width: 15,
          ellipsis: { showTitle: false },
          render: (value) => {
            const formattedDateTime = dayjs(value).format(
              "DD-MM-YYYY hh:mm:ss A"
            );
            return <>{formattedDateTime}</>;
          },
        },
        {
          title: context.translate("_LAST_POLLED_LOCATION_"),
          dataIndex: "location",
          key: "location",
          width: 25,
          ellipsis: { showTitle: false },
        },
        {
          title: context.translate("_FLEET_REPORTS_STOPREPORT_VIEWMAP_"),
          dataIndex: "View",
          key: "View",
          width: 15,
          ellipsis: { showTitle: false },

          render: (value, obj) => {
            return (
              <>
                <Image
                  src={require("../assets/images/mapIcon/gps_icon.png")}
                  width={25}
                  height={25}
                  onClick={async () => {
                    await this.setState({
                      vehicleObj: { ...obj, icon: "map-car-icon-green.png" },
                      heading: "Vehicle Not Poll Map",
                    });
                    await this.setState({ loadData: 1 });
                  }}
                />
              </>
            );
          },
        },
      ],
    };
    this.menuProps = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={Excel}
              ></Image>
              {context.translate("_EXPORT_AS_EXCEL_")}
            </div>
          ),
          key: "excel",
        },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={PDF}
              ></Image>
              {context.translate("_EXPORT_AS_PDF_")}
            </div>
          ),
          key: "pdf",
        },
      ],
      onClick: (val) => {
        let result = [];
        console.log(val);
        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

          //  console.log(result.toString())

          var getData = {
            companyId: this.state.companyId,
            polltime: this.state.polltime,
            uId: null,
            // userId: null,
            colList: result.toString(),
            isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
            // userid: null,
          };
          if (val.key == "excel") {
            // console.log("afd")
            this.vehicleNotPollReportStore.exportExcel(getData);
          }
          if (val.key == "pdf") {
            this.vehicleNotPollReportStore.exportpdf(getData);
          }
          if (val.key == "csv") {
            this.vehicleNotPollReportStore.exportcsv(getData);
          }
          if (val.key == "xml") {
            this.vehicleNotPollReportStore.exportxml(getData);
          }
        }
      },
    };
    this.newColumns = [...this.state.selectedColumns];
  }
  async componentDidMount() {
    // await this.vehicleNotPollReportStore.loadData({ offset: 0, limit: 50 });
    // await this.vehicleNotPollReportStore.loadData({ offset: 0, limit: 50 });
    this.setState({ pageSize: 50 });
    await this.setState({ column: this.state.selectedColumns });
    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }
  }
  async componentDidUpdate(prevProps, prevState) {
    if (this.state.vehicleObj !== prevState.vehicleObj) {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 10);
    }
  }

  async handleChange(comp) {
    await this.setState({ Notcompany: false, pageNo: 1 });
    await this.setState({ companyId: comp?.value });

    // await this.handleSearch();
  }

  async handleSearch() {
    // this.setState({ loading: true });
    await this.vehicleNotPollReportStore.loadData({
      offset: (this.state.pageNo - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
      pageNo: this.state.pageNo,
    });
    await this.setState({ loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    // await this.setState({pageNo:pagination.current})
    // console.log(pagination);
    await this.setState({
      // currentPage: pagination.current,
      pageNo: pagination.current,

      pageSize: pagination.pageSize,

      // pageNo: pagination?.current ? pagination?.current : this.state.pageNo,
      // pageSize: pagination?.pageSize ? pagination?.pageSize : this.state.pageSize,
    });
    await this.showData();
  }

  showData = async () => {
    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }
    if (!this.state.polltime) {
      this.setState({ Nottime: true });
    } else {
      this.setState({ Nottime: false });
    }
    if (this.state.companyId && this.state.polltime) {
      // this.setState({mandatory:false})
      this.setState({ Notcompany: false, Nottime: false });

      await this.vehicleNotPollReportStore.loadData({
        offset: (this.state.pageNo - 1) * this.state.pageSize,
        isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
        userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
        limit: this.state.pageSize,
        companyId: this.state.companyId,
        polltime: this.state.polltime,
        pageNo: this.state.pageNo,
        userid: Number(JSON.parse(base64_decode(Cookies.get("data"))).userId),
      });

      this.setState({ loadData: 1 });
    }
  };

  handleCheckboxChange = async (column) => {
    console.log(column);
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );
      console.log(filtered);
      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      console.log("adsf");
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };

  refreshList = async () => {
    await this.setState({ loading: false, currentPage: 1 });
    await this.showData();
  };
  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={20}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  allowClear={true}
                  onChange={this.handleChange}
                  style={{ width: 150 }}
                  // style={companyInputStyle}
                  status={this.state.Notcompany ? "error" : false}
                />
                <Input
                  style={{ width: 150, borderRadius: "25px" }}
                  status={this.state.Nottime ? "error" : false}
                  // style={timeInputStyle}
                  // placeholder="Time(Min)"
                  placeholder={this.context.translate("_TIME_MIN_")}
                  value={this.state.polltime}
                  onChange={(e) =>
                    this.setState({ polltime: e.target.value, Nottime: false })
                  }
                />
                <Button
                  type="primary"
                  onClick={async () => {
                    // await this.setState({pageSize:,pageNo: 1})
                    // this.handleTableChange();
                    await this.setState({ pageNo: 1, pageSize: 50 });
                    await this.showData();
                  }}
                >
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>

                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={4}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>
                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.vehicleNotPollReportStore?.vehicleNotPollReportStore
                      ?.length > 0
                      ? false
                      : true
                  }
                >
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.menuProps}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "30px",
                      }}
                      src={downloadIcon}
                    ></Image>
                  </Dropdown>
                </Button>
              </Space>
            </Col>
          </Row>

          <Modal
            open={this.state.modalVisible}
            width={300}
            // title="Select Columns"
            title={this.context.translate("_SELECT_COLUMNS_")}
            onCancel={() => this.setState({ modalVisible: false })}
            onOk={() => {
              this.setState({ modalVisible: false });
            }}
            footer={null}
          >
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {console.log(this.newColumns, "Df")}
              {this.newColumns.map((column, v) => {
                return (
                  <Row key={v}>
                    <Col>
                      <Checkbox
                        onChange={() => this.handleCheckboxChange(column)}
                        checked={this.state.selectedColumns.some(
                          (c) => c.key === column.key
                        )}
                      >
                        {column.title}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </Modal>

          <ListTable
            currentPage={this.state.pageNo}
            pageSize={this.state.pageSize}
            total={this.vehicleNotPollReportStore?.total}
            columns={this.state.column}
            dataSource={
              this.vehicleNotPollReportStore?.vehicleNotPollReportStore
            }
            loading={this.vehicleNotPollReportStore?.loading}
            onChange={this.handleTableChange}
            //   pagination={{
            //   pageSize: this.state.pageSize,
            //   //  current:this.state.pageNo
            //   total:this.vehicleNotPollReportStore?.total || 0

            // }}

            // scroll={{
            //   // y: this.state.clientHeight-240,
            //   x: 100,
            // }}
          />

          {/* <Modal
          title="Vehicle Not Poll Map"
          open={this.state.showMap}
          centered
          
          width={850}
          height={400}
          onOk={() => this.setState({ showMap: false })}
          onCancel={() => this.setState({ showMap: false })}
          footer={false}
        >
          <MapContainer
            ref={this.mapRef}
            zoom={16}
            center={[
              this.state.modalInfoObj?.latitude,
              this.state.modalInfoObj?.longitude,
            ]}
            style={{ height: "400px", width: "800px" }}


            bounds={this.state.modalInfoObj ? [[this.state.modalInfoObj.latitude, this.state.modalInfoObj.longitude], [this.state.modalInfoObj.latitude, this.state.modalInfoObj.longitude]] : []}

          >

            <ReactLeafletGoogleLayer />
          

            <Marker
              icon={dotIcon}
              position={[
                this.state.modalInfoObj?.latitude,
                this.state.modalInfoObj?.longitude,
              ]}
            >
                              <Tooltip permanent= {true} direction="top">{this.state.modalInfoObj?.vehicleNo}</Tooltip>
             
            </Marker>
          </MapContainer>
        </Modal> */}

          {this.state.vehicleObj && (
            <MapForVehiclePosition
              vehicleObj={this.state.vehicleObj}
              heading={this.state.heading}
              closeMapModal={(resp) => {
                this.setState({ vehicleObj: resp });
              }}
            />
          )}
        </div>
      </>
    );
  }
}
VehicleNotPollReportList.contextType = StoreContext;
export default observer(withRouter(VehicleNotPollReportList));
